import { EMPTY_STRING } from '../../../../../common/constants/grimsby';
import { ClassroomStatus } from '../../../../interfaces/activity';
import { getStageName } from '../../../../../common/utils/amplify';

type ClassroomsConfig = {
    prod: string;
    gamma: string;
    beta: string;
    sam: string;
    [key: string]: string;
};

export const classroomStatusAlertMap = {
    [ClassroomStatus.CLASSROOM_READY]: {
        type: 'success',
        message: 'Ready',
    },
    [ClassroomStatus.CANCELLED]: {
        type: 'stopped',
        message: 'Cancelled',
    },
    [ClassroomStatus.READY_FOR_CLASSROOM_CREATION]: {
        type: 'in-progress',
        message: `In progress`,
    },
    [ClassroomStatus.ELIGIBLE_FOR_CLASSROOM_CREATION]: {
        type: null,
        message: EMPTY_STRING,
    },
    [ClassroomStatus.CLASSROOM_UPDATE_FAILED]: {
        type: 'error',
        message: 'Failed',
    },
    [ClassroomStatus.CLASSROOM_PROVISIONING_FAILED]: {
        type: 'error',
        message: 'Failed',
    },
};

const DEFAULT_CLASSROOM_URLS: ClassroomsConfig = {
    prod: 'https://instructor.skillbuilder.aws/',
    gamma: 'https://instructor.skillbuilder.training.aws.dev/',
    beta: 'https://us-west-2.beta.instructor.classrooms.aws.training/',
    sam: 'https://us-west-2.beta.instructor.classrooms.aws.training/',
};

const getClassroomUrl = (): string => {
    try {
        // Get configuration and current stage
        const config = window.__CONFIGURATION__ || {};

        if ((config as any).CLASSROOM_URL) {
            return (config as any).CLASSROOM_URL;
        }

        // Fallback logic
        const classrooms = DEFAULT_CLASSROOM_URLS;
        const stageName = getStageName().toLowerCase();

        if (classrooms[stageName]) {
            return classrooms[stageName];
        }

        // Any other value should return prod URL
        return DEFAULT_CLASSROOM_URLS.prod;
    } catch (error) {
        // If anything fails, return the default prod URL
        return DEFAULT_CLASSROOM_URLS.prod;
    }
};

export const CLASSROOM_CONSTANTS = {
    URLS: {
        get CLASSROOMS_PORTAL() {
            return getClassroomUrl();
        },
    },
    MESSAGES: {
        UNSUPPORTED_COURSE:
            'Automatic classroom creation is not supported for this course.',
        CREATE_MANUALLY: 'Create classroom manually.',
    },
    UNSUPPORTED_COURSES: [
        'Custom Class', //https://t.corp.amazon.com/V1715756550
        'Architecting in AWS Classified Regions', //https://t.corp.amazon.com/V1726450212
        'Architecting in AWS for DoD', //https://t.corp.amazon.com/V1726450212
        'AWS Cloud Fundamentals 1: Fun Friday', //https://t.corp.amazon.com/V1726450212
        'AWS Dedicated Cloud: AWS Snowball Edge Provisioning and Usage - Classified Regions', //https://t.corp.amazon.com/V1726450212
        'Video Streaming Essentials for AWS Media Services', //https://t.corp.amazon.com/V1726450212
    ].map((c) => c.toLowerCase()),
} as const;
